var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.isTruncated},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('div',_vm._g(_vm._b({ref:"content",staticClass:"text-truncate",on:{"mouseenter":_vm.checkTruncation}},'div',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }